var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('RawJsonToggler',{attrs:{"json":_vm.workflow}}),_c('h1',[_vm._v(_vm._s(_vm.workflow.workflowName))]),_c('Fieldset',{attrs:{"legend":"Actions"}},[_c('button',{on:{"click":function($event){return _vm.getWorkflow(_vm.workflowId)}}},[_vm._v("refresh")]),(_vm.workflow.parentWorkflowId)?_c('router-link',{attrs:{"tag":"button","to":{
          name: 'workflow',
          params: { workflowId: _vm.workflow.parentWorkflowId }
        }}},[_vm._v("\n        Parent Workflow\n      ")]):_vm._e(),(_vm.workflow.parentWorkflowTaskId)?_c('router-link',{attrs:{"tag":"button","to":{
          name: 'task',
          params: { taskId: _vm.workflow.parentWorkflowTaskId }
        }}},[_vm._v("\n        Parent Workflow Task\n      ")]):_vm._e(),(!_vm.readOnly)?_c('div',[_c('button',{on:{"click":_vm.decideWorkflow}},[_vm._v("decide")]),_c('button',{on:{"click":_vm.pauseWorkflow}},[_vm._v("pause")]),_c('button',{on:{"click":_vm.resumeWorkflow}},[_vm._v("resume")]),_c('router-link',{attrs:{"tag":"button","to":{ name: 'workflowRerun', params: { workflowId: _vm.workflowId } }}},[_vm._v("\n          rerun\n        ")]),_c('router-link',{attrs:{"tag":"button","to":{
            name: 'workflowSkipTask',
            params: { workflowId: _vm.workflowId }
          }}},[_vm._v("\n          skip task\n        ")]),_c('button',{on:{"click":_vm.restartWorkflow}},[_vm._v("restart")]),_c('button',{on:{"click":_vm.retryWorkflow}},[_vm._v("retry last task")]),_c('button',{on:{"click":_vm.stopWorkflow}},[_vm._v("stop")]),_c('button',{on:{"click":_vm.archiveWorkflow}},[_vm._v("archive")]),_c('button',{on:{"click":_vm.removeWorkflow}},[_vm._v("remove")])],1):_vm._e()],1),_c('DataList',{attrs:{"data":_vm.workflow,"attributes":_vm.attributes}}),_c('DataTable',{attrs:{"caption":"Tasks","rowKeys":['taskId'],"rows":_vm.workflow.tasks,"actions":_vm.readOnly
          ? [
              {
                name: 'task',
                label: 'View',
                params: { taskId: 'taskId' }
              }
            ]
          : [
              {
                name: 'task',
                label: 'View',
                params: { taskId: 'taskId' }
              },
              {
                name: 'taskResultEdit',
                label: 'Update',
                params: { taskId: 'taskId' }
              }
            ],"columns":[
        { name: 'seq', type: 'text' },
        { name: 'domain', type: 'text' },
        { name: 'taskType', type: 'text' },
        { name: 'status', type: 'text' },
        { name: 'taskId', type: 'text' },
        { name: 'referenceTaskName', type: 'text' },
        { name: 'scheduledTime', type: 'date' },
        { name: 'pollCount', type: 'text' },
        { name: 'queueWaitTime', type: 'duration' },
        { name: 'startTime', type: 'date' },
        { name: 'updateTime', type: 'date' },
        { name: 'endTime', type: 'date' },
        { name: 'reasonForIncompletion', type: 'text' },
        { name: 'retryCount', type: 'text' },
        { name: 'retriedTaskId', type: 'text' }
      ]}}),_c('hr'),_c('h3',[_vm._v("Workflow Definition")]),_c('EmbedWorkflowDefinition',{attrs:{"workflowDefinition":_vm.workflow.workflowDefinition}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }